module.exports = __webpack_public_path__ + "img/home-bg.acb06ee9.svg";